import {Brick, BrickContext, registerBrick, Transaction, ErrorFlow, Query, CloudObject} from 'olympe';
import JSZip from 'jszip';
import InspectionModule from '../../../models/InspectionModule';
import Version from '../../../models/Version';
import { importSystemFromJSON, matchFileName } from './function/importModuleFromZipFile';
import InspectionState from "../../../models/InspectionState";
import Aspect from "../../../models/Aspect";
import Influence from "../../../models/Influence";

export default class ImportModuleFromZipFile extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {File} zipFile
     * @param {function()} forwardEvent
     * @param {function(*)} setErrorFlow
     * @param {function(*)} setModule
     * @param {function(*)} setVersion
     * @param {function(*)} setSystem
     */
    async update($, [zipFile], [forwardEvent, setErrorFlow, setModule, setVersion, setSystem]) {
        // Read file data
        zipFile.getContentAsBinary().then(async (content) => {
            const jsZip = new JSZip();
            const extractedFiles = await jsZip.loadAsync(content);
            const { files: zipFiles } = extractedFiles;

            const matchedConfigurationFile = matchFileName('configuration.json', zipFiles);
            if (matchedConfigurationFile) {
                const jsonConfig = await zipFiles[matchedConfigurationFile].async('string');
                const parsedConfigFile = JSON.parse(jsonConfig);
                const { module } = parsedConfigFile;

                // CREATE TRANSACTION
                const transaction = new Transaction();

                // SET INSPECTION MODULE PROPERTIES
                const inspectionModuleProperties = new Map();
                inspectionModuleProperties.set(InspectionModule.titleProp, module.title);

                // SET VERSION PROPERTIES
                const versionProperties = new Map();
                versionProperties.set(Version.idProp, module.version);
                versionProperties.set(Version.creationDateProp, new Date());
                versionProperties.set(Version.lastModifiedProp, new Date());
                versionProperties.set(Version.draftProp, false);

                // CREATE TAGS
                const versionTag = transaction.create(Version, versionProperties);
                const inspectionModuleTag = transaction.create(
                    InspectionModule,
                    inspectionModuleProperties
                );

                // Get inspection state list, and map them to their value:
                const inspectionStates = (await Query.instancesOf(InspectionState).execute()).reduce((map, state) => {
                    return map.set(state.getValue().toLowerCase(), state);
                }, new Map());

                // Get aspect list, and map them to their value:
                const factorTargets = new Map();
                (await Query.instancesOf(Aspect).execute()).forEach((aspect) => {
                    factorTargets.set(aspect.getName().toLowerCase(), aspect);
                });

                 // Get influence list, and map them to their value:
                (await Query.instancesOf(Influence).execute()).forEach((influence) => {
                    factorTargets.set(influence.getName().toLowerCase(), influence);
                });

                // Call importSystemFromJSON FN
                const systemTag = await importSystemFromJSON(zipFiles, module.system, versionTag, transaction, $, inspectionStates, factorTargets);

                transaction.createRelation(InspectionModule.versionsRel, inspectionModuleTag, versionTag);

                //  ------- EXECUTE TRANSACTION -------
                transaction
                    .executeAsLarge()
                    .then(() => {
                        setModule(CloudObject.get(inspectionModuleTag));
                        setVersion(CloudObject.get(versionTag));
                        setSystem(CloudObject.get(systemTag));
                        forwardEvent();
                    })
                    .catch((e) => {
                        setErrorFlow(
                            ErrorFlow.create(
                                `An error occurred while processing the transaction to import the module: ${e}`,
                                1
                            )
                        );
                    });
            } else {
                setErrorFlow(ErrorFlow.create('Can\'t parse file', 2)); // Need to finish
            }
        });
    }
}

registerBrick('0189450e32e33bb60a6f', ImportModuleFromZipFile);
